<template>
  <div class="notFound">
    <h1>404 - Not Found</h1>
  </div>
</template>
